import { error } from '@sveltejs/kit';
import type { PageLoad } from './$types';
import {expandedLocation} from '$lib/stores';

export const load = (async ({ params }) => {
  let locationId: number;
  try {
    locationId = parseInt(params.locationId, 10);
  } catch (e) {
    throw error(404, 'Not found');
  }
  expandedLocation.set(undefined);
  return { locationId };
}) satisfies PageLoad;
